import { useMemo, useState } from 'react';
import { SBase, STabs } from '@setvi/shared/components';
import { Box } from '@material-ui/core';

export enum Tabs {
  PRODUCT_MATCH = 'Product Match',
  CATALOG = 'Catalog',
  MANUAL = 'Manual',
  ASKAI = 'Ask AI',
  PRIVATE_LABEL = 'Private Label'
}

interface BaseDialogProps {
  title: string;
  description?: string;
  onClose: () => void;
  elements: {
    content: JSX.Element;
    name: string;
    key: Tabs;
  }[];
  newDesign?: boolean;
}

const BaseDialog = ({
  title,
  description,
  elements,
  onClose,
  newDesign = false
}: BaseDialogProps) => {
  const [tab, setTab] = useState(elements?.[0].key);

  const hasTabs = elements?.length > 1;

  const tabsList = useMemo(() => {
    if (!hasTabs) return [];

    return elements?.map(e => ({
      label: e.name,
      value: e.key
    }));
  }, [hasTabs, elements]);

  const currentContent = useMemo(() => {
    if (!hasTabs) return elements?.[0]?.content;

    return elements?.find(e => e?.key === tab)?.content;
  }, [tab, hasTabs, elements]);

  return (
    <SBase
      header={{
        title,
        onClose,
        description
      }}
      style={{
        background: newDesign ? '#fff' : 'transparent'
      }}
      disablePadding
      width="90vw"
      height="90vh">
      {hasTabs && (
        <STabs
          tabsList={tabsList}
          currentTab={tab}
          handleTabChange={setTab}
          newDesign={newDesign}
        />
      )}

      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          overflow: 'auto'
        }}>
        {!!currentContent && currentContent}
      </Box>
    </SBase>
  );
};

export default BaseDialog;
